import React, { ChangeEvent, FormEvent, useState } from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import Header from "../pages/Header";
import podborkiStore from "../stores/podborkiStore";
import PortalNavigation from "./PortalNavigation";

const PodborkaCreate: React.FC = observer(() => {
  const navigate = useNavigate();
  const [file, setFile] = useState<File | null>(null);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [sort, setSort] = useState(-1);
  const [validationError, setValidationError] = useState<string | null>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    setFile(event.target.files?.[0] ?? null);
    setValidationError(null);
  };

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();

    if (!file || !name.trim() || !description.trim()) {
      setValidationError("Заполните название, описание и выберите картинку");
      return;
    }

    const created = await podborkiStore.createPodborka(
      file,
      name.trim(),
      sort,
      description.trim()
    );

    if (created) navigate("/collections");
  };

  return (
    <Box minHeight="100vh" display="flex" flexDirection="column">
      <Header />
      <Box sx={{ flexGrow: 1, p: 2 }}>
        <PortalNavigation />

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ width: "100%", maxWidth: 1100, mx: "auto" }}
        >
          <Typography variant="h4" fontWeight={700} sx={{ mb: 4 }}>
            Создание жанра/подборки
          </Typography>

          {(validationError || podborkiStore.createError) && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {validationError || podborkiStore.createError}
            </Alert>
          )}

          <Box sx={{ mb: 5 }}>
            <Typography variant="overline" color="text.secondary" display="block" sx={{ mb: 1 }}>
              Загрузить картинку
            </Typography>
            <Button component="label" variant="outlined">
              Выберите файл
              <input hidden type="file" accept="image/*" onChange={handleFileChange} />
            </Button>
            <Typography component="span" sx={{ ml: 1.5 }}>
              {file?.name ?? "Файл не выбран"}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" },
              gap: 2,
            }}
          >
            <TextField
              label="Название подборки"
              value={name}
              onChange={(event) => setName(event.target.value)}
              required
            />
            <TextField
              label="Описание"
              value={description}
              onChange={(event) => setDescription(event.target.value)}
              required
            />
            <TextField
              label="Сортировка"
              type="number"
              value={sort}
              onChange={(event) => setSort(Number(event.target.value))}
              required
            />
          </Box>

          <Box display="flex" gap={2} mt={4}>
            <Button
              type="submit"
              variant="contained"
              startIcon={podborkiStore.createLoading ? <CircularProgress size={18} color="inherit" /> : <SaveOutlinedIcon />}
              disabled={podborkiStore.createLoading}
            >
              Сохранить изменения
            </Button>
            <Button
              variant="outlined"
              color="inherit"
              disabled={podborkiStore.createLoading}
              onClick={() => navigate("/collections")}
            >
              Отмена
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
});

export default PodborkaCreate;
